import http from '@services/http';
import { Users } from './interfaces';

export const guessCountry = (): Promise<Users.GuessCountry.Response> => {
  return http.get(`/users/location/country`);
};